/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('runPackageOperatorEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./run-package-operator-editor.html'),

      replace: true,

      scope: false,

      link(scope, element, attrs) {},

      controller: ['$scope', '$stateParams', function ($scope, $stateParams) {}],
    };
  },
]);
